import { auth } from "../../api";

const useVerifySecurityCode = () => {
  const verifySecurityCode = async (token: string) => {
    try {
      const response = await auth.authPublicGet(`password/reset/?token=${token}`);
      return response.data;
    } catch (error) {
      return error;
    }
  };
  return { verifySecurityCode };
};

export default useVerifySecurityCode;
